import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { PictureSet } from "../models/pictureSets";

@Injectable()
export class PictureSetService {
  private pictureSet: PictureSet;

  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * Get All Picture Set from the API
   * @returns {Observable<any>}
   */
  getAllPictureSets() {
    return this.apiService.get("PictureSet/GetAll");
  }

  setPictureSet(pictureSet: PictureSet) {
    this.pictureSet = pictureSet;
  }

  getPictureSet(): PictureSet {
    return this.pictureSet;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pictureSet.service.ts